import React, { useRef } from "react";
import { Menubar } from "primereact/menubar";
import { TieredMenu } from "primereact/tieredmenu";
import SidebarMenu from "../../common/components/SidebarMenu";
import { Button } from "primereact/button";
import { Outlet, useNavigate, Link } from "react-router-dom";
import { useAuth } from "../../common/contexts/AuthContext";
import { useTheme } from "../../common/contexts/ThemeContext";
import NotificationBell from "../../common/components/Notifications/NotificationBell";
import "../../common/styles/layout.scss";

const PlatformLayout = () => {
  const { logout, user } = useAuth();
  const { isDark, toggleTheme } = useTheme();
  const menuRef = useRef(null);
  const navigate = useNavigate();

  const menuItems = [
    {
      label: "Dashboard",
      icon: "pi pi-fw pi-th-large",
      path: "/platform/dashboard",
      command: () => navigate("/platform/dashboard"),
    },
    {
      label: "Schools",
      icon: "pi pi-fw pi-building",
      path: "/platform/schools",
      command: () => navigate("/platform/schools"),
    },
    {
      label: "Register School",
      icon: "pi pi-fw pi-plus-circle",
      path: "/platform/register-school",
      command: () => navigate("/platform/register-school"),
    },
    {
      label: "Plans",
      icon: "pi pi-fw pi-credit-card",
      path: "/platform/plans",
      command: () => navigate("/platform/plans"),
    },
    {
      label: "Settings",
      icon: "pi pi-fw pi-cog",
      path: "/platform/settings",
      command: () => navigate("/platform/settings"),
    },
    {
      label: "My Profile",
      icon: "pi pi-fw pi-user",
      path: "/platform/profile",
      command: () => navigate("/platform/profile"),
    },
  ];

  const userMenuItems = [
    {
      label: user?.name || "Admin",
      icon: "pi pi-fw pi-user",
      disabled: true,
    },
    {
      label: "Logout",
      icon: "pi pi-fw pi-sign-out",
      command: logout,
    },
  ];

  const end = (
    <div className="flex align-items-center gap-2">
      <NotificationBell />
      <Button
        icon={isDark ? "pi pi-sun" : "pi pi-moon"}
        onClick={toggleTheme}
        className="p-button-rounded p-button-text"
        aria-label="Toggle dark mode"
        tooltip={isDark ? "Light mode" : "Dark mode"}
        tooltipOptions={{ position: 'bottom' }}
      />
      <TieredMenu model={userMenuItems} popup ref={menuRef} />
      <Button
        className="bg-primary"
        icon="pi pi-bars"
        onClick={(event) => menuRef.current.toggle(event)}
      />
    </div>
  );

  return (
    <div className="layout">
      <aside className="layout-sidebar pt-2">
        <Link to="/platform/dashboard" className="flex justify-content-center w-full py-1">
          <img alt="logo" src="/site_logo.png" height="80" className="logo" />
        </Link>
        <div className="px-2 py-2 text-center">
          <span className="text-xs font-semibold text-500 uppercase">Platform Admin</span>
        </div>
        <SidebarMenu items={menuItems} />
      </aside>
      <header className="layout-header">
        <Menubar end={end} />
        <main className="layout-content">
          <Outlet />
        </main>
      </header>
    </div>
  );
};

export default PlatformLayout;
